export function implementationListConfig(getMoney, selectPersonClick, selectDeptClick) {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: true,
    menu: false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: true,
    searchShow:false,
    index: true,
    indexLabel: "序号",
    refreshBtn: true,
    selection: false,
    selectionWidth: 45,
    column: [
      {
        label: '保理合同',
        searchPlaceholder: "请输入保理合同",
        placeholder: '请输入保理合同',
        prop: "contractName",
        searchProp: 'contractName',
        searchkey: 'contractName',
        slot: true,
        search: true,
        overHidden: true,
        slotType: 'linkDetailUrl',
        width: '300',
        searchslot: true,
        bindLabel: 'contractName',
        searchKey: 'contractName',
        bindKey: 'id',
        dataUrl: 'bl/blcontractmanage/page',
        initParam: {
          nameSearch: 1
        },
      },
      {
        sortable: "custom",
        label: '项目编号',
        prop: "projectNumber",
        overHidden: true,
        width: "120",
      },
      {
        label: '项目名称',
        searchPlaceholder: "请输入项目名称",
        placeholder: '请输入项目名称',
        prop: "projectName",
        search: true,
        overHidden: true,
        width: '350'
      },
      {
        label: "承租人",
        prop: '',
        width: '220',

      },
      {
        label: "保理类型",
        prop: "projectType",
        type: "select",
        disabled: false,
        dataType: 'number',
        dicUrl: '/api/blade-system/dict-biz/dictionary?code=foctoring_business_type',
        props: {
          label: "dictValue",
          value: "dictKey"
        },
        width: '150',
      },
      {
        label: '合同金额（元）',
        prop: "factoringCredit",
        searchPlaceholder: "请输入合同金额",
        overHidden: true,
        sortable: "custom",
        width: 150,
        formatter: (row, value, label, column) => {
          return `${getMoney(Number(value))}`;
        },
      },
      {
        label: "内部收益率(%）",
        prop: "xirr",
        width: "120",
        formatter: (row, value, label, column) => {
          return value ? Number((value * 100)).toFixed(4) : ''
        },
        overHidden: true,

      },
      {
        label: "签署时间",
        placeholder: "请选择时间",
        prop: "signDay",
        overHidden: true,
        width: "150"
      },
      {
        label: '合同状态',
        prop: 'dictContractState',
        span: 12,
        search: true,
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=bl_dict_contract_state",
        props: {
          label: "dictValue",
          value: "dictKey"
        },
        dataType: 'number',
        rules: [{
          required: true,
          message: '请选择合同状态',
          // trigger: 'blur'
        }],
        width: '150',
      },
      {
        label: "出租人",
        prop: '',
        width: '220',

      },
      {
        label: '业务主办',
        width: "100",
        prop: "managerUserName",
        overHidden: true,
      }, {
        label: '业务协办',
        width: "100",
        prop: "assistUserName",
        overHidden: true,
      },
      {
        label: '所属部门',
        width: "100",
        prop: "managerDeptName",
        overHidden: true,
      },
      {
        label: "客户类型",
        prop: "custType",
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=cust_type",
        props: {
          label: "dictValue",
          value: "dictKey",
        },
       
        
      },
      {
        label: "企业规模",
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=enterprise_scale",
        prop: 'formEnterpriseScale',
        props: {
          label: "dictValue",
          value: "dictKey"
        }
      },
      {
        label: "所属行业",
        prop: "industry",
        width: "100",
        overHidden: true,
       
      },
      {
        label: "更新时间",
        type: "daterange",
        placeholder: "请选择时间",
        prop: "updateTime",
        overHidden: true,
        width: "150"
      },
    ]
  }
}

